// extracted by mini-css-extract-plugin
export var gif = "_f4-0";